import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M16.726 3.255a.7.7 0 0 1 0 .99l-12.5 12.5a.7.7 0 0 1-.99-.99l12.5-12.5a.7.7 0 0 1 .99 0",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.48 7.96C6.48 5.986 8.063 4.4 10 4.4c1.643 0 3.031 1.144 3.413 2.696l1.103-1.103A4.92 4.92 0 0 0 9.999 3C7.276 3 5.081 5.226 5.081 7.96v2.839c0 .49-.22.952-.596 1.257l-.217.176c-1.144.928-.512 2.816.989 2.816h.204l1.4-1.4H5.257a.16.16 0 0 1-.102-.03.2.2 0 0 1-.062-.09.2.2 0 0 1-.008-.115.17.17 0 0 1 .065-.094l.217-.176A3.02 3.02 0 0 0 6.48 10.8zm2.361 5.688-1.4 1.4h7.3c1.501 0 2.134-1.888.99-2.816l-.217-.176a1.62 1.62 0 0 1-.596-1.257v-2.84q0-.189-.014-.374l-1.386 1.387v1.827c0 .91.408 1.772 1.113 2.344l.217.176a.17.17 0 0 1 .065.094.2.2 0 0 1-.007.114.2.2 0 0 1-.063.091.16.16 0 0 1-.101.03zM8.594 15.6a.7.7 0 1 0 0 1.4h2.81a.7.7 0 1 0 0-1.4z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=BellAlertOffIcon20.js.map